'use client';

/**
 * Monoline Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhySoftwareSection } from '../common/why-software-section';
import { HowSoftwareWorksSection } from '../common/how-software-works-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { CommissionsSection } from '../common/commissions-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { UserPlus, RefreshCw, Users } from 'lucide-react';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.monolinePlan.hero"
                imageSrc="/images/mlm-plans/Monoline_animate.gif"
                descriptionKeys={['description']}
            />
            <WhatIsPlanSection plan={plan} />
            <HowItWorksSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.monolinePlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowSoftwareWorksSection plan={plan} translationNamespace="planDetails.monolinePlan.howSoftwareWorks" />
            <FeaturesSection plan={plan} translationNamespace="planDetails.monolinePlan.features" />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.monolinePlan.advantages"
                advantageKeys={['advantage1', 'advantage2', 'advantage3']}
                gridCols="3"
            />
            <CommissionsSection
                plan={plan}
                translationNamespace="planDetails.monolinePlan.commissions"
                commissions={[
                    { icon: UserPlus, color: 'primary', titleKey: 'sponsor.title', descriptionKey: 'sponsor.description' },
                    { icon: RefreshCw, color: 'blue', titleKey: 'rejoin.title', descriptionKey: 'rejoin.description' },
                    { icon: Users, color: 'green', titleKey: 'matching.title', descriptionKey: 'matching.description' },
                ]}
                gridCols="3"
            />
            <WhySoftwareSection plan={plan} translationNamespace="planDetails.monolinePlan.whySoftware" />
        </div>
    );
}

